<template>
    <div>
        <h4 class="mb-3">Add channel</h4>
        <vx-card id="inputDiv"  class="vs-con-loading__container w-full">
            <div class="vx-row">
                <div class="vx-col lg:w-1/4 w-full">
                    <vs-checkbox class="mt-3" v-model="workerChannel['stream_encrypted']">Stream encrypted</vs-checkbox>
                </div>
                <div class="vx-col lg:w-1/4 w-full">
                    <vs-checkbox class="mt-3" v-model="workerChannel['audio_only']">Audio only</vs-checkbox>
                </div>
                <div class="vx-col lg:w-1/4 w-full">
                    <p>Shaka usage</p>
                    <vs-select autocomplete class="w-full" v-model="workerChannel['shaka_usage']">
                        <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in [{id:0, name: 'Don\'t use'}, {id:1, name: 'FFMpeg + Shaka'}, {id:2, name: 'Shaka only'}]" />
                    </vs-select>
                </div>
            </div>
            <div class="vx-row">
                <div class="vx-col lg:w-1/4 w-full">
                    <p class="mt-6">Name</p>
                    <vs-input v-model="workerChannel['name']" class="w-full"></vs-input>
                </div>
                <div class="vx-col lg:w-1/4 w-full">
                    <p class="mt-6">Serialized name (only alphanumeric and underscore)</p>
                    <vs-input v-model="workerChannel['serialized_name']" class="w-full"></vs-input>
                </div>
                <div class="vx-col lg:w-1/4 w-full">
                    <p class="mt-6">Channel</p>
                    <vs-select autocomplete class="w-full" v-model="workerChannel['channel_id']">
                        <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in channels" />
                    </vs-select>
                </div>
                <div class="vx-col lg:w-1/4 w-full mt-6 mb-6" v-if="possibleGPUs.length > 1">
                    <p>GPU</p>
                    <vs-select autocomplete class="w-full" v-model="workerChannel['gpu']">
                        <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in possibleGPUs" />
                    </vs-select>
                </div>
            </div>
            <div class="vx-row mt-6">
                <!--<div class="vx-col lg:w-1/3 w-full mt-6 mb-6">
                    <h4>Input template</h4>
                    <vs-select autocomplete class="w-full" v-model="workerChannel['in_template'].id">
                        <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in inputTemplates" />
                    </vs-select>
                    <div v-if="inputTemplateMap[workerChannel['in_template'].id] && inputTemplateMap[workerChannel['in_template'].id].params.length > 0">
                        <h6 class="mt-6">Template parameters</h6>
                        <div class="w-full vx-row mb-4" :key="item.key" v-for="item in inputTemplateMap[workerChannel['in_template'].id].params">
                            <div class="vx-col w-1/2">
                                <vs-checkbox class="mt-3" v-model="enabledInputTemplateParameters" :vs-value="item.key">{{item.name}}</vs-checkbox>
                            </div>
                            <div class="vx-col w-1/2">
                                <vs-input v-if="enabledInputTemplateParameters.includes(item.key)" v-model="inputTemplateParams[item.key]" class="w-full"></vs-input>
                                <vs-input v-else disabled v-model="item.default" class="w-full"></vs-input>
                            </div>

                        </div>
                    </div>
                </div>-->
                <div class="vx-col lg:w-1/3 w-full mt-6 mb-6" v-if="workerChannel['shaka_usage'] < 2">
                    <p>Work template</p>
                    <vs-select autocomplete class="w-full" v-model="workerChannel['work_template'].id">
                        <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in workTemplates" />
                    </vs-select>
                    <div v-if="workTemplateMap[workerChannel['work_template'].id] && workTemplateMap[workerChannel['work_template'].id].params.length > 0">
                        <h6 class="mt-6">Template parameters</h6>
                        <div class="w-full vx-row mb-4" :key="item.key" v-for="item in workTemplateMap[workerChannel['work_template'].id].params">
                            <div class="vx-col w-1/2">
                                <vs-checkbox class="mt-3" v-model="enabledWorkTemplateParameters" :vs-value="item.key">{{item.name}}</vs-checkbox>
                            </div>
                            <div class="vx-col w-1/2">
                                <vs-input v-if="enabledWorkTemplateParameters.includes(item.key)" v-model="workTemplateParams[item.key]" class="w-full"></vs-input>
                                <vs-input v-else disabled v-model="item.default" class="w-full"></vs-input>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="vx-col lg:w-1/3 w-full mt-6 mb-6" v-if="workerChannel['shaka_usage'] < 2">
                    <p>Output template</p>
                    <vs-select autocomplete class="w-full" v-model="workerChannel['out_template'].id">
                        <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in outputTemplates" />
                    </vs-select>
                    <div v-if="outputTemplateMap[workerChannel['out_template'].id] && outputTemplateMap[workerChannel['out_template'].id].params.length > 0">
                        <h6 class="mt-6">Template parameters</h6>
                        <div class="w-full vx-row mb-4" :key="item.key" v-for="item in outputTemplateMap[workerChannel['out_template'].id].params">
                            <div class="vx-col w-1/2">
                                <vs-checkbox class="mt-3" v-model="enabledOutputTemplateParameters" :vs-value="item.key">{{item.name}}</vs-checkbox>
                            </div>
                            <div class="vx-col w-1/2">
                                <vs-input v-if="enabledOutputTemplateParameters.includes(item.key)" v-model="outputTemplateParams[item.key]" class="w-full"></vs-input>
                                <vs-input v-else disabled v-model="item.default" class="w-full"></vs-input>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="vx-col lg:w-1/3 w-full mt-6 mb-6" v-if="workerChannel['shaka_usage'] > 0">
                    <p>Shaka template</p>
                    <vs-select autocomplete class="w-full" v-model="workerChannel['shaka_template'].id">
                        <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in shakaTemplates" />
                    </vs-select>
                    <div v-if="shakaTemplateMap[workerChannel['shaka_template'].id] && shakaTemplateMap[workerChannel['shaka_template'].id].params.length > 0">
                        <h6 class="mt-6">Template parameters</h6>
                        <div class="w-full vx-row mb-4" :key="item.key" v-for="item in shakaTemplateMap[workerChannel['shaka_template'].id].params">
                            <div class="vx-col w-1/2">
                                <vs-checkbox class="mt-3" v-model="enabledShakaTemplateParameters" :vs-value="item.key">{{item.name}}</vs-checkbox>
                            </div>
                            <div class="vx-col w-1/2">
                                <vs-input v-if="enabledShakaTemplateParameters.includes(item.key)" v-model="shakaTemplateParams[item.key]" class="w-full"></vs-input>
                                <vs-input v-else disabled v-model="item.default" class="w-full"></vs-input>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <vs-divider/>

            <vs-button :disabled="!inputValid" icon-pack="feather" icon="icon-plus" color="success" class="mt-6; mr-1" @click="addChannel">Add channel</vs-button>

        </vx-card>
    </div>
</template>
<script>

    export default {
        data() {
            return {

                workerChannel: {
                    channel_id: 0,
                    name: '',
                    serialized_name: '',
                    gpu: '',
                    shaka_usage: 0,
                    stream_encrypted: false,
                    upstream_type: 0,
                    upstream_worker_id: 0,
                    upstream_cluster_id: 0,
                    upstream_channel_id: 0,
                    in_template: {
                        id: 0
                    },
                    work_template: {
                        id: 0
                    },
                    out_template: {
                        id: 0
                    },
                    shaka_template: {
                        id: 0
                    },
                    audio_only: false
                },

                channels: [],

                inputTemplates: [],
                workTemplates: [],
                outputTemplates: [],

                enabledInputTemplateParameters: [],
                inputTemplateParams: {},

                enabledWorkTemplateParameters: [],
                workTemplateParams: {},

                enabledOutputTemplateParameters: [],
                outputTemplateParams: {},

                enabledShakaTemplateParameters: [],
                shakaTemplateParams: {},

                possibleGPUs: []

            }
        },
        methods: {
            loadData() {
                this.$vs.loading({
                    container: '#inputDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this

                const channelsPromise = this.$http.get('/api/management/v1/channel/')
                channelsPromise.then(function(response) {
                    thisIns.channels = response.data
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                const inputTemplatePromise = this.$http.get('/api/management/v1/template/?type=0')
                inputTemplatePromise.then(function(response) {
                    thisIns.inputTemplates = response.data
                    thisIns.inputTemplates.push({ id: 0, name: 'Default', params: [] })
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                const workTemplatePromise = this.$http.get('/api/management/v1/template/?type=1')
                workTemplatePromise.then(function(response) {
                    thisIns.workTemplates = response.data
                    thisIns.workTemplates.push({ id: 0, name: 'Default', params: [] })
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                const outputTemplatePromise = this.$http.get('/api/management/v1/template/?type=2')
                outputTemplatePromise.then(function(response) {
                    thisIns.outputTemplates = response.data
                    thisIns.outputTemplates.push({ id: 0, name: 'Default', params: [] })
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                const shakaTemplatePromise = this.$http.get('/api/management/v1/template/?type=3')
                shakaTemplatePromise.then(function(response) {
                    thisIns.shakaTemplates = response.data
                    // thisIns.shakaTemplates.push({ id: 0, name: 'Default', params: [] })
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                const GPUsPromise = thisIns.$http.get('/api/management/v1/worker/' + this.$route.params.id)
                GPUsPromise.then(function(response) {
                    thisIns.possibleGPUs = [{ id: '', name: 'All' }]
                    for (let x = 0; x < response.data.gpu.length; x++) {
                        thisIns.possibleGPUs.push({
                            id: response.data.gpu[x].uuid,
                            name: (response.data.gpu[x].custom_name.length > 0) ? response.data.gpu[x].custom_name : response.data.gpu[x].uuid
                        })
                    }
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                Promise.all([channelsPromise, inputTemplatePromise, workTemplatePromise, outputTemplatePromise, shakaTemplatePromise, GPUsPromise]).then(function() {
                    if (thisIns.channels.length > 0) {
                        thisIns.workerChannel.channel_id = thisIns.channels[0].id
                    }
                }).finally(function() {
                    thisIns.$vs.loading.close('#inputDiv > .con-vs-loading')
                })
            },
            addChannel() {
                this.$vs.loading({
                    container: '#inputDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const inputTemplateParams = []
                for (let i = 0; i < this.enabledInputTemplateParameters.length; i++) {
                    if (this.inputTemplateParams.hasOwnProperty(this.enabledInputTemplateParameters[i])) {
                        inputTemplateParams.push({
                            key: this.enabledInputTemplateParameters[i],
                            value: this.inputTemplateParams[this.enabledInputTemplateParameters[i]]
                        })
                    }
                }

                const workTemplateParams = []
                for (let i = 0; i < this.enabledWorkTemplateParameters.length; i++) {
                    if (this.workTemplateParams.hasOwnProperty(this.enabledWorkTemplateParameters[i])) {
                        workTemplateParams.push({
                            key: this.enabledWorkTemplateParameters[i],
                            value: this.workTemplateParams[this.enabledWorkTemplateParameters[i]]
                        })
                    }
                }

                const outputTemplateParams = []
                for (let i = 0; i < this.enabledOutputTemplateParameters.length; i++) {
                    if (this.outputTemplateParams.hasOwnProperty(this.enabledOutputTemplateParameters[i])) {
                        outputTemplateParams.push({
                            key: this.enabledOutputTemplateParameters[i],
                            value: this.outputTemplateParams[this.enabledOutputTemplateParameters[i]]
                        })
                    }
                }

                const shakaTemplateParams = []
                for (let i = 0; i < this.enabledShakaTemplateParameters.length; i++) {
                    if (this.shakaTemplateParams.hasOwnProperty(this.enabledShakaTemplateParameters[i])) {
                        shakaTemplateParams.push({
                            key: this.enabledShakaTemplateParameters[i],
                            value: this.shakaTemplateParams[this.enabledShakaTemplateParameters[i]]
                        })
                    }
                }

                const thisIns = this

                const addPromise = this.$http.post('/api/management/v1/worker/' + this.$route.params.id + '/channel', {
                    name: this.workerChannel.name,
                    serialized_name: this.workerChannel.serialized_name,
                    channel_id: this.workerChannel.channel_id,
                    gpu: this.workerChannel.gpu,
                    shaka_usage: this.workerChannel.shaka_usage,
                    stream_encrypted: this.workerChannel.stream_encrypted,
                    in_template: {
                        id: Number(this.workerChannel.in_template.id),
                        params: inputTemplateParams
                    },
                    work_template: {
                        id: Number(this.workerChannel.work_template.id),
                        params: workTemplateParams
                    },
                    out_template: {
                        id: Number(this.workerChannel.out_template.id),
                        params: outputTemplateParams
                    },
                    shaka_template: {
                        id: Number(this.workerChannel.shaka_template.id),
                        params: shakaTemplateParams
                    },
                    audio_only: this.workerChannel.audio_only
                })

                addPromise.then(function() {
                    thisIns.$printSuccess('Channel added')
                    thisIns.$vs.loading.close('#inputDiv > .con-vs-loading')
                    thisIns.$router.push('/worker/' + thisIns.$route.params.id)
                })

                addPromise.catch(function(error) {
                    thisIns.$printError(error.response.data)
                    thisIns.$vs.loading.close('#inputDiv > .con-vs-loading')
                })
            }
        },
        computed: {
            inputTemplateMap() {
                const templatesMap = {}
                for (let i = 0; i < this.inputTemplates.length; i++) {
                    templatesMap[this.inputTemplates[i].id] = this.inputTemplates[i]
                }

                return templatesMap
            },
            workTemplateMap() {
                const templatesMap = {}
                for (let i = 0; i < this.workTemplates.length; i++) {
                    templatesMap[this.workTemplates[i].id] = this.workTemplates[i]
                }

                return templatesMap
            },
            outputTemplateMap() {
                const templatesMap = {}
                for (let i = 0; i < this.outputTemplates.length; i++) {
                    templatesMap[this.outputTemplates[i].id] = this.outputTemplates[i]
                }

                return templatesMap
            },
            shakaTemplateMap() {
                const templatesMap = {}
                for (let i = 0; i < this.shakaTemplates.length; i++) {
                    templatesMap[this.shakaTemplates[i].id] = this.shakaTemplates[i]
                }

                return templatesMap
            },
            inputValid() {
                if (this.workerChannel.name.length === 0) return false
                if (this.workerChannel.serialized_name.length === 0) return false

                if (this.workerChannel.channel_id === 0) return false

                return true
            }
        },
        watch: {
            'workerChannel.in_template.id'() {
                if (!this.inputTemplateMap[this.workerChannel.in_template.id]) return
                this.enabledInputTemplateParameters = []
                for (let i = 0; i < this.inputTemplateMap[this.workerChannel.in_template.id].params.length; i++) {
                    this.$set(this.inputTemplateParams, this.inputTemplateMap[this.workerChannel.in_template.id].params[i].key, this.inputTemplateMap[this.workerChannel.in_template.id].params[i].default)
                }
            },
            'workerChannel.work_template.id'() {
                if (!this.workTemplateMap[this.workerChannel.work_template.id]) return
                this.enabledWorkTemplateParameters = []
                for (let i = 0; i < this.workTemplateMap[this.workerChannel.work_template.id].params.length; i++) {
                    this.$set(this.workTemplateParams, this.workTemplateMap[this.workerChannel.work_template.id].params[i].key, this.workTemplateMap[this.workerChannel.work_template.id].params[i].default)
                }
            },
            'workerChannel.out_template.id'() {
                if (!this.outputTemplateMap[this.workerChannel.out_template.id]) return
                this.enabledOutputTemplateParameters = []
                for (let i = 0; i < this.outputTemplateMap[this.workerChannel.out_template.id].params.length; i++) {
                    this.$set(this.outputTemplateParams, this.outputTemplateMap[this.workerChannel.out_template.id].params[i].key, this.outputTemplateMap[this.workerChannel.out_template.id].params[i].default)
                }
            },
            'workerChannel.shaka_template.id'() {
                if (!this.shakaTemplateMap[this.workerChannel.shaka_template.id]) return
                this.enabledShakaTemplateParameters = []
                for (let i = 0; i < this.shakaTemplateMap[this.workerChannel.shaka_template.id].params.length; i++) {
                    this.$set(this.shakaTemplateParams, this.shakaTemplateMap[this.workerChannel.shaka_template.id].params[i].key, this.shakaTemplateMap[this.workerChannel.shaka_template.id].params[i].default)
                }
            }
        },
        mounted() {
            this.loadData()
        }
    }

</script>
